"use client";

import { useEffect } from "react";

/**
 * Inside the YouCan Seller Area iframe, Qantra injects a live session JWT on
 * same-origin fetch so the server can recover the store session if cookies are
 * partitioned or missing.
 */
export function YoucanEmbedBridge() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const inIframe = window.self !== window.top;
    const flagged = document.cookie.split(";").some((c) => c.trim().startsWith("snopdesk_youcan_embed="));
    if (!inIframe && !flagged) return;

    const script = document.createElement("script");
    script.type = "module";
    script.dataset.youcanQantra = "1";
    script.textContent = `
      try {
        const mod = await import("https://cdn.jsdelivr.net/npm/@youcan/qantra@1.0.0-beta.6/+esm");
        const api = mod.default ?? mod;
        if (typeof api.initialize === "function") await api.initialize();
      } catch (err) {
        console.warn("[youcan] qantra init skipped", err);
      }
    `;
    document.head.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);

  return null;
}
